import { observer } from 'mobx-react-lite'
import { useJobDetailsViewModel } from '@/features/jobs/details/JobDetailsView'
import { LinkDocumentsDialog } from '@/features/docs/components/LinkDocumentsDialog'
import { ConsultationJobDetailsViewModel } from '@/features/jobs/details/consultation-type/ConsultationJobDetailsViewModel'
import { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { PageLayout } from '@/features/jobs/details/components/PageLayout'
import type { JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { DocumentsSectionContainer } from '@/features/jobs/details/components/DocumentsSection'
import { useActivation } from '@/hooks/view-model-hooks'
import TaxJobDocsTab from '@/features/jobs/details/tax-type/components/TaxJobDocsTab'
import ConsultationDocsTab from '@/features/jobs/details/consultation-type/components/ConsultationDocsTab'

/**
 * Job documents tab.
 */
export default observer(function DocsTab() {
  const vm = useJobDetailsViewModel()

  return (
    <>
      {renderDocsTab(vm)}
      <LinkDocumentsDialog
        vm={vm.docsVm.linkDocumentsVm}
        testId="link-documents-dialog"
        doneButtonTestId="link-documents-dialog-done-button"
      />
    </>
  )
})

/**
 * Renders the docs tab based on the job type.
 * .
 * @param vm
 */
function renderDocsTab(vm: JobDetailsViewModel) {
  if (vm.typeVm instanceof TaxJobDetailsViewModel) {
    return <TaxJobDocsTab vm={vm} />
  }

  if (vm.typeVm instanceof ConsultationJobDetailsViewModel) {
    return <ConsultationDocsTab vm={vm} />
  }

  return <DefaultDocsTab vm={vm} />
}

interface DefaultDocsTabProps {
  vm: JobDetailsViewModel
}

/**
 * Default docs tab.
 */
const DefaultDocsTab = observer(function DefaultDocsTab({
  vm,
}: DefaultDocsTabProps) {
  useActivation(vm.docsVm)
  return (
    <>
      <PageLayout>
        <DocumentsSectionContainer vm={vm} />
      </PageLayout>
    </>
  )
})
